module.exports = __webpack_public_path__ + "static/media/linea_4.e686b87a.svg";